import React, {useEffect} from 'react';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import {useKeycloak} from "@react-keycloak/web";
import * as Sentry from "@sentry/react";
import {jwtDecode} from "jwt-decode";
import RouteWrapper from "./routes";
import TranslationProvider from "../provider/translation";
import {AccessProvider, getJwtLanguage, getUserResources, ResourceProvider} from "@dreebit-registry/vsm-microservice-components";
import i18n from "../i18n/config";

interface KeycloakTokenPayload {
    sub?: string;
    email?: string;
    preferred_username?: string;
    name?: string;
    locale?: string;
    realm_access?: {
        roles?: string[];
    };
    resource_access?: Record<string, { roles?: string[] }>;
}

const RoutesIndex = () => {

    const { keycloak, initialized } = useKeycloak();

    useEffect(() => {
        if (initialized && !keycloak.authenticated) {
            keycloak.login()
                .then((res) => {

                })
                .catch((err) => {
                    console.warn('Error during keycloak login: ', err)
                })
                .finally(() => {
                })
            ;
        }

        if (keycloak.authenticated && keycloak.token) {
            const language = getJwtLanguage(keycloak.token);
            const currentLang = window.sessionStorage.getItem('lng');

            // Update if language changed
            if (language !== currentLang) {
                window.sessionStorage.setItem('lng', language);
                i18n.changeLanguage(language); // Sync to i18n instance
            }

            // Set Sentry user context from Keycloak token
            // Note: username/email excluded for data privacy
            try {
                const decoded = jwtDecode<KeycloakTokenPayload>(keycloak.token);
                const resources = getUserResources(keycloak.token, 'otto_installed_base');

                // Set user identity (only ID for privacy)
                Sentry.setUser({
                    id: decoded.sub,
                });

                // Set additional context with roles and resources
                Sentry.setContext("keycloak", {
                    locale: decoded.locale,
                    realmRoles: decoded.realm_access?.roles,
                    resources: resources,
                });
            } catch (err) {
                console.warn('Error setting Sentry user context:', err);
            }
        }
    }, [keycloak, initialized])

    return (
        <TranslationProvider>
            <BrowserRouter>
                <AccessProvider keycloakToken={keycloak.token} app={'installedBase'}>
                    <ResourceProvider keycloakToken={keycloak.token} microService={'otto_installed_base'}>
                        <Routes>
                            <Route path="/*" element={<RouteWrapper/>} />
                        </Routes>
                    </ResourceProvider>
                </AccessProvider>
            </BrowserRouter>
        </TranslationProvider>
    );
}

export default RoutesIndex;
